/*
  RevoRope — estado "nav compacto" de la cabecera al pasar el hero.

  Qué hace: añade la clase `is-compacto` a `.rr-header` cuando `.rr-hero` deja de
  estar en pantalla, y la quita al volver a subir. TODO el tratamiento visual vive
  en CSS (assets/base.css, bloque "Estado nav compacto"); este archivo sólo escribe
  una clase.

  Por qué existe aparte: responsabilidad distinta de assets/rr-nav.js (mega-menú de
  escritorio + overlay móvil), igual que rr-carousel.js y rr-cinta.js viven
  separados aunque los dos muevan carruseles. Este archivo NO toca el nav ni el
  overlay: abrir/cerrar sigue funcionando idéntico en los dos estados.

  Contrato de seguridad:
   - Sólo la Home tiene `.rr-hero`. En cualquier otra página (producto, colección,
     FAQ, carrito...) sale en silencio y la cabecera se queda exactamente como hoy.
   - Sin IntersectionObserver (navegador viejo) tampoco hace nada: se queda el
     estado por defecto, que es el que ya estaba en producción.
   - El umbral se toma del token `--rr-giro-top` que ya declara `.rr-hero` en
     home.css ("alto real de la cabecera"): así el cambio ocurre justo cuando el
     filo inferior del hero se mete DEBAJO de la banda del header, no 80px más
     tarde. No se duplica la constante: si cambia allí, cambia aquí.
*/
(function () {
  'use strict';

  var header = document.querySelector('.rr-header');
  var hero = document.querySelector('.rr-hero');

  // Páginas sin hero (todas menos la Home): nada que hacer.
  if (!header || !hero) return;
  if (!('IntersectionObserver' in window)) return;

  var CLASE = 'is-compacto';

  // Alto de la banda del header, leído del token del hero. Si no se pudiera leer
  // (orden de hojas de estilo raro), 73px es el valor documentado por defecto.
  var banda = parseFloat(getComputedStyle(hero).getPropertyValue('--rr-giro-top'));
  if (!isFinite(banda) || banda <= 0) banda = 73;

  var io = new IntersectionObserver(
    function (entries) {
      for (var i = 0; i < entries.length; i++) {
        header.classList.toggle(CLASE, !entries[i].isIntersecting);
      }
    },
    { root: null, rootMargin: '-' + Math.round(banda) + 'px 0px 0px 0px', threshold: 0 }
  );

  io.observe(hero);
})();
